export const ROLES = {
	ADMIN: '6169a0c1283fbe31af55ab82'
};

export const ORGANIZATIONS = {
	GEPP: 'GEPP'
};

export const PRESETS = {
	NBA: '69e6c20236b5f7ccc0bc2417'
};
